import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import './styles/global.css';
import { setRefreshHandler } from './api/client';
import { queryClient } from './api/queryClient';
import { App } from './app/App';
import i18n from './i18n';

document.documentElement.lang = i18n.language;
document.title = i18n.t('app.title');
setRefreshHandler(() => void queryClient.refetchQueries({ type: 'active' }));

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
